import React, { useEffect, useRef, useState } from 'react'
import * as PropTypes from 'prop-types'
import './OptionsDropdown.scss'

// interface IProps {
//   buttonContent: React.ReactNode | string
//   buttonClass?: string
//   children: React.ReactNode
//   showOnTop?: boolean
// }

/**
 * Usage:
 *     <OptionsDropdown buttonContent={<i className={'fas fa-ellipsis-h'} />} buttonClass="button" >
 *       <button onClick={...}>Accept</button>
 *       <button onClick={...}>Cancel</button>
 *     </OptionsDropdown>
 */

const OptionsDropdown = props => {
  const [isOpen, setIsOpen] = useState(false)
  const [isMounted, setIsMounted] = useState(false)
  const node = useRef(null)
  // const style = useSpring(isOpen ? { maxHeight: 300 } : { maxHeight: 0 })

  // Effect to watch mousedown events
  useEffect(() => {
    if (!isMounted) {
      setIsMounted(true)
    } else {
      if (!isOpen) {
        document.removeEventListener('mousedown', handleClick)
      } else {
        document.addEventListener('mousedown', handleClick)
      }
    }

    return () => {
      document.removeEventListener('mousedown', handleClick)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen])

  return (
    <div
      className={`dropdown-container ${props.showOnTop ? 'to-top' : ''} ${isOpen ? 'is-open' : 'is-closed'}`}
      ref={node}
    >
      <button onClick={toggleDropdown} className={`main-button ${props.buttonClass}`}>
        {props.buttonContent}
      </button>

      <div className="dropdown-options-container">
        <div className="dropdown-options-inner" onClick={toggleDropdown}>
          {props.children}
        </div>
      </div>
    </div>
  )

  /**
   * Toggle dropdown
   * @param {React.ChangeEvent<any>} e
   */
  function toggleDropdown(e) {
    e.preventDefault()
    e.stopPropagation()
    setIsOpen(!isOpen)
  }

  /**
   *
   * @param {any} e
   */
  function handleClick(e) {
    const current = node.current
    if (!current || current.contains(e.target)) {
      // inside click
      return
    }

    // outside click
    if (isOpen) {
      setIsOpen(false)
    }
  }
}

OptionsDropdown.propTypes = {
  buttonContent: PropTypes.any.isRequired,
  buttonClass: PropTypes.string,
  children: PropTypes.any,
  showOnTop: PropTypes.bool
}

export default React.memo(OptionsDropdown)
